<template>
<div>
    <TextArea v-model.trim="value" :type="props.type || 'text'" :placeholder="props.placeholder" :class="props.class" :maxlength="maxFieldChar" />
    <span class="flex justify-between items-center">
        <small v-if="worningMessage !== ''" class="text-red-600"> {{ worningMessage }}</small> 
        <small v-else class="text-red-600">{{ errorMessage || '&nbsp;' }}</small> 
        <p v-show="maxFieldChar > 0" style="font-size: 0.96rem">{{ countedChar }}/{{ maxFieldChar }}</p> 
    </span>
</div>
</template>
<script setup>
import { ref, watch } from "vue"
import TextArea from "primevue/textarea"
import { useField } from 'vee-validate';
import utils from "@/composables/utils";
import { translate } from "@/composables/translate";


const props = defineProps({
    name:  {
        type: String,
        required: true
    },
    type:  {
        type: String,
        required: false
    },
    placeholder:  {
        type: String,
        required: false
    },
    class: {
        type: String,
        required: false,
        default: ''
    },
    maxFieldChar: {
        type: Number,
        required: false,
        default: 0
    }
  });

let countedChar = ref(0)
let worningMessage = ref('')

let { value, errorMessage } = useField(() => props.name);

watch(() => value.value, (newValue) => {
  countedChar.value = utils.countCharacters(newValue)

  countedChar.value >= props.maxFieldChar
  ? worningMessage = translate('this field must be at most '+props.maxFieldChar+' characters', 'ucfirst')
  : worningMessage = ''
});

</script>
